import {
  BaselineRequest,
  BulkImportInitResponse,
  BulkImportStatus,
  BulkImportType,
  DARequest,
  GraphDataResponse,
  ScheduleRequest
} from '@dr-customer-offers-ui/lib-interfaces';
import { createAction, props } from '@ngrx/store';
import { NgxDropdownOption } from 'ngx-dropdown';
import { OffersDataInterface, RegConfig } from '../../shared/models';
import { Role } from '../../shared/models/role';
import { User } from '../../shared/models/user.model';

// User actions
export const userReceived = createAction('[Window Event] User Data Received', props<{ user: User }>());

// Roles actions
export const rolesReceived = createAction('[Window Event] User Roles Received', props<{ roles: Role[] }>());

// Load Programs Actions
export const loadPrograms = createAction('[Programs] Load Programs');
export const loadProgramsSuccess = createAction(
  '[Programs API] Load Programs Success',
  props<{ programs: NgxDropdownOption[]; selectedProgram: NgxDropdownOption }>()
);
export const loadProgramsFailure = createAction('[Programs API] Load Programs Failure', props<{ error: string }>());

export const selectProgram = createAction('[Programs] Select Program', props<{ program: NgxDropdownOption }>());

// Load Registrations Actions
export const loadRegistrations = createAction('[Registrations] Load Registrations', props<{ programId: string }>());
export const loadRegistrationsUsingSession = createAction('[Registrations] Load Registrations Using Session');
export const loadRegistrationsSuccess = createAction(
  '[Registrations API] Load Registrations Success',
  props<{ registrations: NgxDropdownOption[]; selectedRegistration: NgxDropdownOption | null }>()
);
export const loadRegistrationsFailure = createAction('[Registrations API] Load Registrations Failure', props<{ error: string }>());

export const cancelLoadRegistrations = createAction('[Registrations] Cancel Load Registrations');

// RegViewConfig Actions
export const loadRegViewConfig = createAction('[RegViewConfig] Load Registration View Config', props<{ registrationId: string }>());

export const loadRegViewConfigSuccess = createAction(
  '[RegViewConfig API] Load Registration View Config Success',
  props<{
    registrationId: string;
    regViewConfig: RegConfig;
  }>()
);

export const loadRegViewConfigFailure = createAction(
  '[RegViewConfig API] Load Registration View Config Failure',
  props<{
    registrationId: string;
    error: string;
  }>()
);

// Graph Offers Actions
export const loadGraphOffers = createAction(
  '[Graph Offers] Load Graph Offers',
  props<{
    currentDate: string;
  }>()
);

export const loadGraphOffersSuccess = createAction(
  '[Graph Offers API] Load Graph Offers Success',
  props<{
    graphOffers: GraphDataResponse | null;
  }>()
);

export const loadGraphOffersFailure = createAction(
  '[Graph Offers API] Load Graph Offers Failure',
  props<{
    error: string;
  }>()
);

// Open Offers Actions
export const loadOpenOffers = createAction('[Offers Open] Load Offers', props<{ registrationId: string; startDate: string; endDate: string }>());
export const loadOpenOffersSuccess = createAction('[Offers Open API] Load Offers Success', props<{ offers: OffersDataInterface }>());
export const loadOpenOffersFailure = createAction('[Offers Open API] Load Offers Failure', props<{ error: string }>());

// Cleared Offers Actions
export const loadClearedOffers = createAction(
  '[Offers Cleared] Load Cleared Offers',
  props<{ registrationId: string; startDate: string; endDate: string }>()
);
export const loadClearedOffersSuccess = createAction('[Offers Cleared API] Load Cleared Offers Success', props<{ offers: OffersDataInterface }>());
export const loadClearedOffersFailure = createAction('[Offers Cleared API] Load Cleared Offers Failure', props<{ error: string }>());

// Cleared Graph Offers Actions
export const loadClearedGraphOffers = createAction(
  '[Cleared Graph Offers] Load Cleared Graph Offers',
  props<{ registrationId: string; currentDate: string }>()
);

export const loadClearedGraphOffersSuccess = createAction(
  '[Cleared Graph Offers API] Load Cleared Graph Offers Success',
  props<{
    graphOffers: GraphDataResponse | null;
  }>()
);

export const loadClearedGraphOffersFailure = createAction(
  '[Cleared Graph Offers API] Load Cleared Graph Offers Failure',
  props<{
    error: string;
  }>()
);

// Schedule offers Actions
export const loadScheduledOffers = createAction('[Offers Scheduled] Load Scheduled Offers');
export const loadScheduledOffersSuccess = createAction(
  '[Offers Scheduled API] Load Scheduled Offers Success',
  props<{ offers: OffersDataInterface }>()
);
export const loadScheduledOffersFailure = createAction('[Offers Scheduled API] Load Scheduled Offers Failure', props<{ error: string }>());

// Baseline offers Actions
export const loadBaselineOffers = createAction('[Offers Baseline] Load Baseline Offers');
export const loadBaselineOffersSuccess = createAction('[Offers Baseline API] Load Baseline Offers Success', props<{ offers: OffersDataInterface }>());
export const loadBaselineOffersFailure = createAction('[Offers Baseline API] Load Baseline Offers Failure', props<{ error: string }>());

// DA Offers Actions
export const loadDAOffers = createAction('[Offers DA] Load DA Offers', props<{ registrationId: string; startDate: string; endDate: string }>());
export const loadDAOffersSuccess = createAction('[Offers DA API] Load DA Offers Success', props<{ offers: OffersDataInterface }>());
export const loadDAOffersFailure = createAction('[Offers DA API] Load DA Offers Failure', props<{ error: string }>());

// DA Offers POST Actions
export const postDAOffers = createAction(
  '[Offers DA] Post DA Offers',
  props<{ offers: DARequest[]; registrationId: string; startDate: string; endDate: string }>()
);
export const postDAOffersSuccess = createAction('[Offers DA API] Post DA Offers Success');
export const postDAOffersFailure = createAction('[Offers DA API] Post DA Offers Failure', props<{ error: string }>());

// Baseline Offers POST Actions
export const postBaselineOffers = createAction(
  '[Offers Baseline] Post Baseline Offers',
  props<{ offers: BaselineRequest[]; registrationId: string; startDate: string; endDate: string }>()
);
export const postBaselineOffersSuccess = createAction('[Offers Baseline API] Post Baseline Offers Success');
export const postBaselineOffersFailure = createAction('[Offers Baseline API] Post Baseline Offers Failure', props<{ error: string }>());

// Schedule Offers POST Actions
export const postScheduledOffers = createAction('[Offers Scheduled] Post Scheduled Offers', props<{ offers: ScheduleRequest[] }>());
export const postScheduledOffersSuccess = createAction('[Offers Scheduled API] Post Scheduled Offers Success');
export const postScheduledOffersFailure = createAction('[Offers Scheduled API] Post Scheduled Offers Failure', props<{ error: string }>());

// Schedule Offers Put actions
export const putScheduledOffers = createAction('[Offers Scheduled] Put Scheduled Offers', props<{ offers: ScheduleRequest[] }>());
export const putScheduledOffersSuccess = createAction('[Offers Scheduled API] Put Scheduled Offers Success');
export const putScheduledOffersFailure = createAction('[Offers Scheduled API] Put Scheduled Offers Failure', props<{ error: string }>());

// Bulk Import actions
export const initiateBulkImport = createAction(
  '[Bulk Import] Initiate',
  props<{ registrationId: string; importName: string; importType: BulkImportType }>()
);
export const bulkImportInitSuccess = createAction('[Bulk Import] Init Success', props<{ initResponse: BulkImportInitResponse }>());
export const bulkImportUploadProgress = createAction('[Bulk Import] Upload Progress', props<{ progress: number }>());
export const bulkImportUploadComplete = createAction('[Bulk Import] Upload Complete');
export const bulkImportStatusReceived = createAction(
  '[Bulk Import] Status Received',
  props<{
    status: BulkImportStatus;
    importType: BulkImportType;
    rowsInvalid?: number;
    totalRows: number;
    rowsProcessed: number;
    percent: number;
  }>()
);
export const bulkImportCompleted = createAction('[Bulk Import] Completed', props<{ status: BulkImportStatus }>());
export const bulkImportFailed = createAction('[Bulk Import] Failed', props<{ error: string }>());
export const bulkImportReset = createAction('[Bulk Import] Reset');
